import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { appHttpClient } from '@framework';
import { UserModel, GuestModel } from '@models';
import { environment as env } from 'environments/environment';

@Injectable()
export class UserServices {
    private get _endpoint() { return env.app_apiURL + '/user' }
    private get _authpoint() { return env.authURL + '/user' }

    //TODO: Implement for CPP 
    private get _cpppoint() { return env.cpp_apiURL + '/doctors' }

    constructor(@Inject('appHttpClient') private _httpClient: appHttpClient) { }

    Find(_user?: UserModel) {
        let _endpoint = this._endpoint;
        if (_user) {
            _endpoint += '?' + _user.toQueryParamData();
        }
        return this._httpClient.Get(_endpoint)
            .map(res => res.json());
    }

    GetUserExists(_userID?: string, _username?: string, _email?: string): Observable<any> {
        let params = '';
        if (_userID) {
            params += ';UserID=' + _userID;
        }
        if (_username) {
            params += ';Username=' + _username;
        }
        if (_email) {
            params += ';Email=' + _email;
        }
        params = params.length ? encodeURIComponent(params.substring(1)) : '';

        return this._httpClient.Get(`${this._endpoint}/exist/${params}`)
            .map((res: any) => res.json());

    }

    Insert(_user: UserModel, _password: any): any {
        const _guest = new GuestModel(_user);
        _guest.Password = _password;
         return this._httpClient.Post(`${this._endpoint}`, _guest.toJSONData());
    }

    Update(_user): any {
        // return this._httpClient.Put(`${this._endpoint}/${_user.UserID}`, _user.toJSONData());
        return this._httpClient.Put(`${this._endpoint}`, _user.toJSONData());
 
     }

    UpdateMe(_user): any {
       // return this._httpClient.Put(`${this._endpoint}/${_user.UserID}`, _user.toJSONData());
       return this._httpClient.Put(`${this._endpoint}/me`, _user.toJSONData());

    }

    setUserActiveStatus(_userID: string, _status: boolean): any {
        const __status = _status ? 'isActive' : 'isInactive';
        return this._httpClient.Put(`${this._endpoint}/${_userID}/status/${__status}`, null);
    }
 
    setPassword(_guest: GuestModel): any {
        return this._httpClient.Put(`${this._endpoint}/reset-password`, _guest.toJSONData());
    }

    setPasswordMe(_guest: GuestModel): any {
        return this._httpClient.Put(`${this._endpoint}/me/reset-password`, _guest.toJSONData());
    }

    Delete(_userID: string): any {
        return this._httpClient.Delete(`${this._endpoint}/${_userID}`);
    }



    setLoggedInUser(_user: UserModel): void {
        localStorage.setItem("LoggedInUser", JSON.stringify(_user))
      };

      getLoggedInUser(): UserModel {
        const _value = localStorage.getItem('LoggedInUser');
        return _value ? JSON.parse(_value) : null;
      };


      saveUserSettings(_AppSettings) {
        return Observable.create((_operator) => {
            this._httpClient.Put(this._authpoint + '/settings', JSON.stringify(_AppSettings))
                .subscribe(
                    (_Response: any) => {
                       
                        _operator.next("Saved");
                    }, (_error) => { _operator.error(_error); }
                );
        });
    }


    GetUserMenu(): Observable<any> {    
        return this._httpClient.Get(`${this._endpoint}/menu`)
            .map((res: any) => res.json());
    }

    GetUserInstanceDetails(_InstanceID): Observable<any> { 
        let _endpoint = env.app_apiURL + '/projects' + '/instance/' + _InstanceID;
        return this._httpClient.Get(_endpoint).map(res => res.json());
    }


    GetUserProfileExtendedInfo(_LoggedinUser) {
        const _endpoint = _LoggedinUser.apiURL + _LoggedinUser.ProfileURL + _LoggedinUser.UserID;
        return this._httpClient.Get(_endpoint).map((res) => res.json());
      }

};
